import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';

export type ClientDashboardReadySectionProps = {
  capabilityCount: number;
  ratedCount: number;
  totalToRate: number;
};

export function ClientDashboardReadySection({
  capabilityCount,
  ratedCount,
  totalToRate,
}: ClientDashboardReadySectionProps) {
  const allRated = totalToRate > 0 && ratedCount >= totalToRate;

  return (
    <>
      <div className="client-dash__step-cards">
        <article className="client-dash__step-card client-dash__step-card--done">
          <header className="client-dash__step-card-head">
            <span className="client-dash__step-card-badge client-dash__step-card-badge--done">
              <Check size={14} strokeWidth={2.5} aria-hidden />
            </span>
            <span className="client-dash__step-card-phase">Step 1 · Done</span>
          </header>
          <h3 className="client-dash__step-card-title">
            {capabilityCount} {capabilityCount === 1 ? 'capability' : 'capabilities'} selected
          </h3>
          <p className="client-dash__step-card-desc">
            Your focus areas are set. You can still review or edit your selection anytime.
          </p>
          <Link
            to="/capabilities"
            className="app-btn app-btn--outline app-btn--sm client-dash__step-card-btn"
          >
            Review selection
          </Link>
        </article>

        <article className="client-dash__step-card client-dash__step-card--next">
          <header className="client-dash__step-card-head">
            <span className="client-dash__step-card-badge">2</span>
            <span className="client-dash__step-card-phase">Step 2 · Up next</span>
          </header>
          <h3 className="client-dash__step-card-title">Start the assessment</h3>
          <p className="client-dash__step-card-desc">
            Rate the current and target state for each selected capability.
          </p>
          <div className="client-dash__step-card-actions">
            <Link
              to="/assessment"
              className="app-btn app-btn--primary app-btn--sm client-dash__step-card-btn client-dash__step-card-btn--primary"
            >
              {allRated ? 'Continue assessment' : 'Start assessment'}
              <ArrowRight size={16} aria-hidden />
            </Link>
            <span className="client-dash__step-card-progress">
              {ratedCount} of {totalToRate} rated
            </span>
          </div>
        </article>
      </div>
    </>
  );
}

export default ClientDashboardReadySection;
